export function isMobile() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || navigator.standalone === true
}

export function onInstalled(cb) {
  const handler = () => cb()
  window.addEventListener('appinstalled', handler)

  const mql = window.matchMedia('(display-mode: standalone)')
  const mqlHandler = (e) => { if (e.matches) cb() }
  if (mql.addEventListener) mql.addEventListener('change', mqlHandler)
  else if (mql.addListener) mql.addListener(mqlHandler)

  return () => {
    window.removeEventListener('appinstalled', handler)
    if (mql.removeEventListener) mql.removeEventListener('change', mqlHandler)
    else if (mql.removeListener) mql.removeListener(mqlHandler)
  }
}

export const SHOW_INSTALL_EVENT = 'mindesk:show-install-prompt'

export function requestShowInstallPrompt() {
  window.dispatchEvent(new CustomEvent(SHOW_INSTALL_EVENT))
}
